import React from 'react';
import { useTranslation } from '../shared/i18n';
import useDocumentTitle from '../shared/hooks/useDocumentTitle';
import ResourcesSection from '../shared/components/ResourcesSection';
import * as S from './RecursosPage.styles';

function RecursosPage() {
  const t = useTranslation();
  useDocumentTitle();

  return (
    <S.PageContainer>
      <S.Header>
        <S.Title>{t('resources.title')}</S.Title>
        <S.Subtitle>{t('resources.subtitle')}</S.Subtitle>
      </S.Header>
      
      <S.ContentSection>
        <ResourcesSection />
      </S.ContentSection>
    </S.PageContainer>
  );
}

export default RecursosPage;

